import React from "react"
import {useParams} from "react-router-dom"
import Wiki from "components/wiki/Wiki"
import "./WikiPage.css"

export default function WikiPage({page: pageProp}) {

    const params = useParams()
    const page = pageProp ?? params.page

    return <Wiki page={page} className="shadow white"/>
}
